import { BookingFlow, Cart, Order } from '@flysas-tech/book-value-stream-models';
import * as T from '@sinclair/typebox';

import { StringEnumSchema } from '../../../utils/types';
import { ReservationErrorCode } from '../../sas-domain/reservation';

export type RevenueCreateOrderRequestBody = T.Static<typeof RevenueCreateOrderRequestBody>;
export const RevenueCreateOrderRequestBody = T.Object({
  cartId: T.String(),
  redirectUrl: T.String(),
  bookingFlow: StringEnumSchema(BookingFlow),
  showVBR: T.Optional(T.Boolean()),
});

export type RevenueCreateOrderResponse = T.Static<typeof RevenueCreateOrderResponse>;
export const RevenueCreateOrderResponse = T.Object({
  order: Order,
  cart: Cart,
  reservationErrorCode: T.Optional(StringEnumSchema(ReservationErrorCode)),
});
